import React, {FC} from 'react';
import styles from './DeprecationBanner.module.less';

interface DeprecationBannerProps {
    mp3Url: string;
    message: string;
    linkText?: string;
}

const DeprecationBanner: FC<DeprecationBannerProps> = ({mp3Url, message, linkText = 'Go to new Marketplace'}) => {
    return (
        <div className={styles.banner}>
            <div className={styles.content}>
                <span>{message}</span>
            </div>
            {mp3Url && (
                <a href={mp3Url} target="_blank" rel="noopener noreferrer" className={styles.link}>
                    {linkText} &rarr;
                </a>
            )}
        </div>
    );
};

export default DeprecationBanner;
